export default "__VITE_ASSET__CIoW15op__"